module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"abhijit":"Абхиджит-мухурта","rahukala":"Раху-Кала"}}')
  delete Component.options._Ctor
}
